import { useState } from 'react';
import { Modal, ModalBody, Button, Alert } from 'reactstrap';
import { getUser } from '../../services/auth';

type SessionExpiryModalProps = {
    isOpen: boolean;
    onSessionExtended: () => void;
};

export const SessionExpiryModal = ({
    isOpen,
    onSessionExtended,
}: SessionExpiryModalProps) => {
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleStaySignedIn = async () => {
        setSubmitting(true);
        setError(null);

        try {
            const resp = await getUser();
            if (resp.error) {
                setError('Unable to extend your session. Please log in again.');
                setSubmitting(false);
                return;
            }
            setSubmitting(false);
            onSessionExtended();
        } catch {
            setError('Unable to extend your session. Please log in again.');
            setSubmitting(false);
        }
    };

    return (
        <Modal
            centered
            isOpen={isOpen}
            backdrop='static'
            keyboard={false}
            size='md'
        >
            <ModalBody className='p-4'>
                <div className='text-center mb-4'>
                    <h3 className='text-modal modal__title'>
                        Session Expiring Soon
                    </h3>
                    <p className='text-muted'>
                        Your session will expire in 5 minutes due to inactivity.
                        Click the button below to stay signed in. Unsaved changes
                        may be lost.
                    </p>
                </div>

                {error && (
                    <Alert color='danger' className='py-2'>
                        {error}
                    </Alert>
                )}

                <div className='text-center'>
                    <Button
                        color='primary'
                        onClick={handleStaySignedIn}
                        disabled={submitting}
                    >
                        {submitting ? 'Extending session...' : 'Stay Signed In'}
                    </Button>
                </div>
            </ModalBody>
        </Modal>
    );
};
